export default "__VITE_ASSET__7ac21e39__"